export default "__VITE_ASSET__B3wFk4po__"